import { render, staticRenderFns } from "./MobilePaletteModal.vue?vue&type=template&id=c14f5e90&"
import script from "./MobilePaletteModal.vue?vue&type=script&lang=ts&"
export * from "./MobilePaletteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MobilePaletteModal.vue"
export default component.exports